module.exports = __webpack_public_path__ + "img/third-onboarding-1.c52f41b8.png";